<template>
  <CModal
    @mtdclosemodal="mtdClose"
    :show.sync="boo_modal"
    :close-on-backdrop="false"
    :centered="true"
    :title="title"
    :size="'lg'"
    :btn_cancel="true"
    :btn_ok="true"
    :booTitile="true"
    :scrollable="true"
  >
    <div class="row">
      <div class="table-responsive mb-2 mt-3">
        <table class="table table-bordered">
          <thead>
            <tr>
              <th colspan="12" class="bg-main text-white">
                <div class="d-flex justify-content-between align-items-center">
                  <span class="mx-auto">MONTURAS MODELO</span>
                </div>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in orden.mounts" :key="index">
              <td colspan="7">
                <div class="d-flex align-items-center">
                  <input
                    v-model="item.search_mount_name"
                    type="text"
                    class="form-control w-25 text-center me-1"
                    placeholder="Buscar"
                    @keyup.enter="mtdAddMonturas(item, index)"
                  />
                  <input
                    v-model="item.mount_name"
                    type="text"
                    class="form-control w-75 text-center"
                    placeholder="Montura"
                    disabled
                  />
                </div>
              </td>
              <td colspan="3">
                <div class="d-flex align-items-center">
                  <strong class="me-3 space" style="text-align: left"
                    >PRECIO</strong
                  >
                  <input
                    v-model="item.mount_price"
                    type="text"
                    class="form-control w-100 text-center"
                    @keydown="filterKey"
                    :disabled="!item.mount_name"
                  />
                </div>
              </td>
              <td v-if="index == orden.mounts.length - 1" class="text-center">
                <button @click="addRow" class="btn btn-sm btn-success">
                  <span class="button-mount">+</span>
                </button>
              </td>
              <td
                v-if="orden.mounts.length > 1"
                class="text-center"
                :colspan="orden.mounts.length > 1 ? 2 : 1"
              >
                <button @click="removeRow(index)" class="btn btn-sm btn-danger">
                  <span class="button-mount">-</span>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <template #footer>
      <button @click="mtdVerifData()" class="btn btn-success btn-sm">
        <i class="fa fa-save" />&nbsp; Guardar
      </button>
    </template>
    <cModalMonturasVue
      :data="data"
      :title="modalMonturas.title"
      :boo_modal="modalMonturas.modal_form"
      :pos="modalMonturas.pos"
      :search="modalMonturas.search"
      @closeModal="closeModalMonturas"
      @add="addMonturas"
    />
    <SweetAlert :swal="swal" ref="SweetAlert" />
  </CModal>
</template>

<script>
import CModal from "../../shared/modals/CModal.vue";
import { mapActions } from "vuex";
import moment from "moment";
import SweetAlert from "@/components/shared/SweetAlert/SweetAlert.vue";
import cModalMonturasVue from "@/components/Admision/modal/OrdenTrabajo/cModalMonturas.vue";
export default {
  name: "c-cxc-cModalAddMontCarrito",
  components: {
    CModal,
    cModalMonturasVue,
    SweetAlert,
  },
  data() {
    return {
      swal: null,
      tabla: [],
      data: [],
      orden: {
        mounts: [
          {
            mount_name: "",
            mount_id: null,
            mount_price: 0,
            dispatch_detail_id: null,
          },
        ],
      },
      modalMonturas: {
        title: "",
        modal_form: false,
        pos: null,
        search: null,
      },
    };
  },
  created() {},
  computed: {
    cpData() {},
  },
  props: {
    title: String,
    boo_modal: Boolean,
    item: [],
    idSale: Number,
  },
  methods: {
    ...mapActions(["get", "post"]),

    mtdClose() {
      this.clear();
      this.$emit("mtdCloseAddService");
    },

    filterKey: function (e) {
      let b = false;
      b = /^[0-9.]$/.test(e.key);
      if (!b && e.key !== "Backspace") {
        e.preventDefault();
      }
    },

    //Modal Montura
    mtdAddMonturas: function (item, index) {
      if (item.search_mount_name.length > 2) {
        this.get({
          url:
            this.$store.getters.get__url +
            "/Venta/particular/null/" +
            this.$store.getters.get__campus +
            "/subsubcategories?search_product=" +
            item.search_mount_name,
          token: this.$store.getters.get__token,
        }).then((response) => {
          let data = response.data.data;
          if (data.length == 1 && data[0].typeSearch == "code") {
            this.addMonturas(data[0], index);
          } else {
            this.modalMonturas = {
              title: "Lista de Monturas",
              modal_form: true,
              pos: index,
              search: item.search_mount_name,
            };
            this.data = data;
          }
        });
      } else {
        this.$refs.SweetAlert.showWarning("Digite Montura. Max 3 Caracteres");
      }
    },

    closeModalMonturas: function () {
      this.modalMonturas = {
        title: "",
        modal_form: false,
        pos: null,
        search: null,
      };
    },

    addMonturas: function (payload, pos) {

        // const existeMontura = this.orden.mounts.some(mount => mount.mount_id === payload.id);
        // if (existeMontura) {
        //     this.$refs.SweetAlert.showWarning("La montura ya está en el carrito y no se puede agregar nuevamente");
        //     return;
        // }

      // Filtrar los elementos del carrito con el mismo mount_id y barcode
      const existingMounts = this.orden.mounts.filter(
        (mount) =>
          mount.mount_id === payload.id && mount.barcode === payload.barcode
      );

      // Contar la cantidad actual en el carrito
      let totalInCart = existingMounts.length;
      let stockDisponible = payload.total_stock;

      // Verificar si la cantidad en el carrito supera el stock disponible
      if (totalInCart >= stockDisponible) {
        Swal.fire({
          icon: "warning",
          title: "Stock insuficiente",
          text: `Stock disponible: ${stockDisponible}. Ya has agregado ${totalInCart} a tu carrito, no puedes agregar más.`,
        });
        return;
      }

      // Asignar los valores si la validación pasa
      this.orden.mounts[pos].mount_name = payload.name;
      this.orden.mounts[pos].mount_id = payload.id;
      this.orden.mounts[pos].search_mount_name = "";
      this.orden.mounts[pos].mount_price = payload.precio_farmacia_particular;
      this.orden.mounts[pos].barcode = payload.barcode;
      this.orden.mounts[pos].dispatch_detail_id = payload.dispatch_detail_id;
    },

    addRow() {
      this.orden.mounts.push({ mount_name: "", mount_price: 0 });
    },
    removeRow(index) {
      if (this.orden.mounts.length > 1) {
        this.orden.mounts.splice(index, 1);
      }
    },

    mtdVerifData: function () {
      let emptyMountName = this.orden.mounts.some(
        (mount) => mount.mount_name.trim() == ""
      );
      if (emptyMountName) {
        this.$refs.SweetAlert.showWarning(
          "Todos los nombres de Monturas deben estar Completos",
          "warning"
        );
        return;
      }
      this.mtdSaveData();
    },

    mtdSaveData: function () {
      this.post({
        url: this.$store.getters.get__url + "/cxc/mtdAddMont",
        token: this.$store.getters.get__token,
        params: {
          data: this.orden.mounts,
          idSale: this.idSale,
        },
      })
        .then((response) => {
          if (response.statusCode == 200) {
            this.$refs.SweetAlert.showSuccess("Agregado Correctamente");
            this.mtdClose();
            this.$emit("mtdSaveAddService");
          }
        })
        .catch((errors) => {
          this.$refs.SweetAlert.showError(errors);
        });
    },

    clear() {
      this.data = [];
      this.orden = {
        mounts: [
          {
            mount_name: "",
            mount_id: null,
            mount_price: 0,
            dispatch_detail_id: null,
          },
        ],
      };
    },
  },
  filters: {
    formatDate(date) {
      return date != null ? moment(date).format("DD/MM/YYYY") : "-";
    },
    formatTime(time) {
      let arTime = time.split(":");
      if (arTime[0] <= 12) {
        return time + " am";
      } else {
        return arTime[0] - 12 + ":" + arTime[1] + ":" + arTime[2] + " pm";
      }
    },
  },
};
</script>
